<template>
  <FloatMenu />
  <div class="layout text-align-center">
    <Header data-scroll />
    <main>
      <RouterView />
    </main>
    <Footer data-scroll />
  </div>
</template>

<script setup>
defineOptions({ name: "LayoutHome" });
import Header from "../components/page/Header.vue";
import Footer from "../components/page/Footer.vue";
import FloatMenu from "../components/FloatMenu.vue";
</script>
